import React from 'react'
import { ColumnRank, ColumnStartOrder, ColumnName, ColumnNoc, ColumnExpander, ColumnResult, ColumnPoints, ColumnExtendedResult } from "components/common/TableColumns"
import { ColumnRankOfIntermediate } from "components/common/TableColumnsIntermediates";
import ResultRank from "components/presentation/ResultRank";
import { findArray, sortDataByFieldDesc, filterArray } from 'helpers/utils'
import Label from "components/general/Label"
import SportCode, { useSportCode } from 'components/common/SportCode'
export function TableColumnsLive(configNode, isMobile, selectedSplit) {

    let columns = [
        ColumnRankOfIntermediateSelected({ selectedSplit: selectedSplit, disableSort: false }),
        ColumnRank({}),
        ColumnRankOfIntermediate({ onlyRank: true, disableSort: false }),
        ColumnStartOrder({ label: 'StartNum' }),
        ColumnNoc({}),
        ColumnName({}),
        ColumnExtendedResult({label: 'HeaderTime', code: 'LASER_RUN', type: 'ER_LR'}),
        ColumnResult({label: 'HeaderPoints'}),        
        ColumnExpander({})
    ]
/*
    const extColumns = getColumnsExt(configNode, isMobile)
    if (extColumns.length > 1) {
        columns = [...columns, ...extColumns]
    }
    return (
        columns
    )*/
    return columns
}


export default TableColumnsLive
//Columns Splits 
function getColumnsExt(configNode, isMobile) {
    const configFilter = filterArray(configNode, { type: ['LR'], code: ['INTERMEDIATE'] });
    sortDataByFieldDesc(configFilter, 'pos');
    let columnsExt = []
    columnsExt = Array.isArray(configFilter) && configFilter.map((item, index) => {
        return (
            {
                Header: () => {
                    const code = item?.extension?.find(x => x !== undefined)?.value //first element defined in this way must be always LAP value
                    const desc = SportCode({ entity: "@IntPtType", code: code, isText: true })
                    const extension = (desc ? desc : '')
                    const ind = Label({ data: 'LabelMetres' })
                    let caption
                    if (item?.pos === 'F') {
                        caption = Label({ data: 'LabelFinish' }) + ' - ' + item?.value + ind
                    } else {
                        caption = extension + ' - ' + item?.value + ind
                    }
                    return caption
                },
                accessor: (props) => {
                    const intermediate = findArray(props?.extendedResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: [item.pos] });
                    const sortOrder = Number(intermediate.er_sortorder)
                    return sortOrder
                },
                sortType: "absoluteOrderNumber",
                disableSortBy: false,
                isVisible: false,
                columnIndex: index + 1,
                id: 'ResultEx' + (index + 1),
                className: 'text-end',
                headerClassName: 'text-end w-15',
                Cell: (props) => {
                    const row = props?.cell?.row?.original;
                    const intermediate = findArray(row?.extendedResults, { er_type: ['PROGRESS'], er_code: ['INTERMEDIATE'], er_pos: [item.pos] });
                    let res = ""
                    if (isMobile || item.pos === "F") { //|| item.pos === row?.finalSplit
                        if (intermediate && intermediate?.er_rank === '1') {
                            res = intermediate?.er_value
                        } else {
                            res = intermediate?.er_diff
                        }
                    } else {
                        if (intermediate && intermediate?.er_rank === '1') {
                            res = <ResultRank result={intermediate?.er_value} rank={intermediate?.er_rank} />
                        } else {
                            res = <ResultRank result={intermediate?.er_diff} rank={intermediate?.er_rank} />
                        }
                    }

                    /*
                     else if (item.er_pos === 'F') {
                         res = <SportCode code={row.resultIrm} discipline={mirs_discipline} entity="@IRM" abbr={true} />
                     }
                    */
                    return (res);
                }
            }
        )
    })
    return columnsExt
}





//Ver si es generico o cambia el ei_code -  Usado en CRD en el evento time trial
export function ColumnRankOfIntermediateSelected({
    disableSort = true,
    className = 'text-end',
    headerClassName = 'text-end w-10',
    label = 'HeaderRank',
    selectedSplit = 1
}) {


    return (
        {
            Header: <Label data={label} />,
            accessor: (props) => {
                let sel = selectedSplit;
                if (String(selectedSplit) === props?.finalSplit) { sel = 'F' }
                return (
                    props?.extendedResults
                        ? findArray(props.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [String(sel)] })?.er_sortorder
                        : ''
                )
            },
            sortType: "absoluteOrderNumber",
            className: className,
            headerClassName: headerClassName,
            disableSortBy: disableSort,
            id: 'RankOfIntermediateSelected',

            Cell: (props) => {
                let row = props.cell.row.original;
                let sel = selectedSplit;
                if (String(selectedSplit) === row?.finalSplit) { sel = 'F' }

                let rank = findArray(row.extendedResults, { er_code: ['INTERMEDIATE'], er_pos: [String(sel)] })?.er_rank
                rank = (rank !== undefined) ? rank : ''

                return (
                    (props.cell.row.original.resultType !== 'IRM')
                        ? rank
                        : ''
                )
            },

        }
    )
}

